import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  overlay: {
    zIndex: 1,
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
});

export default styles;
